import momentZone from 'moment-timezone';
import moment from 'moment'; 
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';

import {
  GET_REGISTERED_COMPANIES_LIST_GQL,
  GET_REGISTERED_CARDS_LIST_GQL,
  GET_RECENT_LOGGED_IN_USER_GQL,
  GET_CARD_TRANSACTION_COUNT_GQL,
  GET_ACTIVITY_STATUS_LIST_GQL,
  GET_NEXT_STEP_LIST_GQL,
  GET_REGISTERED_COMPANIES_CARDS_COUNT_GQL,
  GET_REGISTERED_CARDS_COUNT_GQL,
  GET_RECENTLY_REGISTERED_COMPANIES_LIST_GQL,
  SET_RECENTLY_REG_COMP_COL_SEL_GQL,
  GET_MARQETA_TRANSACTION_LIST_GQL,
  SET_RESET_MARQETA_RAW_DATA_RECORD_GQL,
  GET_PROGRAM_BALANCE_GQL
} from '@/graphql/superAdmin.gql';

export default {
  namespaced: true,
  state: {
    recentLoggedInUser: null,
    cardTransactionCount: null,
    registeredCompaniesList: null,
    registeredCardsList: null,
    activityStatusList: null,
    nextStepList: null,
    registeredCompaniesCardsCount: null,
    companyCardFilterOffset: null,
    registeredCardsCount: null,
    cardTypeFilter: null,
    companyElTableColumn: [],
    recentlyRegisteredCompaniesList: null,
    updatedCardType: null,
    marqetaTransactions: null,
    updatedMarqetaRawDataRecord: null,
    programBalance: null,
  },
  mutations: {
    SET_COMPANY_CARD_FILTER_OFFSET(state, payload) {
      state.companyCardFilterOffset = payload;
    },
    GET_REGISTERED_COMPANIES_CARDS_COUNT(state, payload) {
      state.registeredCompaniesCardsCount = payload;
    },
    GET_REGISTERED_COMPANIES_LIST(state, payload) {
      state.registeredCompaniesList = payload;
    },
    GET_RECENTLY_REGISTERED_COMPANIES_LIST(state, payload) {
      state.recentlyRegisteredCompaniesList = payload;
    },
    GET_REGISTERED_CARDS_LIST(state, payload) {
      state.registeredCardsList = payload;
    },
    GET_RECENT_LOGGED_IN_USER(state, payload) {
      state.recentLoggedInUser = payload;
    },
    GET_CARD_TRANSACTION_COUNT(state, payload) {
      state.cardTransactionCount = payload;
    },
    GET_ACTIVITY_STATUS_LIST(state, payload) {
      state.activityStatusList = payload;
    },
    GET_NEXT_STEP_LIST(state, payload) {
      state.nextStepList = payload;
    },
    GET_REGISTERED_CARDS_COUNT(state, payload) {
      state.registeredCardsCount = payload;
    },
    SET_CARD_TYPE_FILTER(state, payload) {
      state.cardTypeFilter = payload;
    },
    SET_COMPANY_EL_TABLE_COLUMN(state, payload) {
      state.companyElTableColumn = payload;
    },
    SET_UPDATED_CARD_TYPE(state, payload) {
      state.updatedCardType = payload;
    },
    GET_MARQETA_TRANSACTION_LIST(state,payload) {
      state.marqetaTransactions = payload;
    },
    GET_PROGRAM_BALANCE(state,payload) {
      state.programBalance = payload;
    },
    SET_RESET_MARQETA_RAW_DATA_RECORD(state, payload) {
      state.updatedMarqetaRawDataRecord = payload;
    }
  },
  actions: {
    async getCardTransactionCount({ commit }, _payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_CARD_TRANSACTION_COUNT_GQL,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_CARD_TRANSACTION_COUNT', data.getCardTransactionCount);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getRecentLoggedInUsers({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_RECENT_LOGGED_IN_USER_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
          addTypename: false,
        })
        .then(({ data }) => {
          commit('GET_RECENT_LOGGED_IN_USER', data.userSettingses);

          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getRecentLoggedInUserserr) => {
          console.log(getRecentLoggedInUserserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getRecentlyRegisteredCompaniesList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_RECENTLY_REGISTERED_COMPANIES_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          data.getRecentlyRegisteredCompaniesList.forEach((company, index) => {
            if (company.users.length > 0) {
              if (company.users[0].UserSettings.length > 0) {
                company.users[0].UserSettings.forEach((userSetting) => {
                  if (userSetting.companyId === company.id) {
                    data.getRecentlyRegisteredCompaniesList[index].users[0].UserSettings = [];
                    data.getRecentlyRegisteredCompaniesList[index].users[0].UserSettings.push(userSetting);
                  }
                });
              }
            }
          });
          commit('GET_RECENTLY_REGISTERED_COMPANIES_LIST', data.getRecentlyRegisteredCompaniesList);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getRecentlyRegisteredCompaniesListerr) => {
          console.log(getRecentlyRegisteredCompaniesListerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getRegisteredCompaniesList({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_REGISTERED_COMPANIES_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          data.getRegisteredCompaniesList.forEach((company, index) => {
            let resetUserObj = true;
            if (company.users.length > 0) {
              company.users.forEach((user) => {
                user.UserSettings.forEach((userSetting) => {
                  if (userSetting.companyId === company.id) {
                    if (resetUserObj) {
                      const userObj = user;
                      userObj.UserSettings = [];
                      userObj.UserSettings.push(userSetting);
                      data.getRegisteredCompaniesList[index].users = [];
                      data.getRegisteredCompaniesList[index].users.push(userObj);
                      resetUserObj = false;
                    }
                  }
                });
              });
            }
          });

          commit('GET_REGISTERED_COMPANIES_LIST', data.getRegisteredCompaniesList);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((getRegisteredCompaniesListerr) => {
          console.log(getRegisteredCompaniesListerr);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        });
    },
    async getRegisteredCardsList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_REGISTERED_CARDS_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_REGISTERED_CARDS_LIST', data.getRegisteredCardsList);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getRegisteredCardsListerr) => {
          console.log(getRegisteredCardsListerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getRegisteredCompaniesCardsCount({ commit }, payload) {
      const createdDate = momentZone()
        .tz('America/New_York')
        .subtract(payload.filterOffSet, 'hours')
        .format('YYYY-MM-DDTHH:MM');
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      const variablesObj = {
        createdDate,
      };
      if (payload.instrumentType) {
        variablesObj.instrumentType = payload.instrumentType;
      }
      await apolloClient
        .query({
          query: GET_REGISTERED_COMPANIES_CARDS_COUNT_GQL,
          variables: variablesObj,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_REGISTERED_COMPANIES_CARDS_COUNT', data.getCompaniesCardsCount);
          commit('SET_COMPANY_CARD_FILTER_OFFSET', payload.filterOffSet);
          commit('SET_CARD_TYPE_FILTER', payload.instrumentType);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getRegisteredCompaniesCardsCounterr) => {
          console.log(getRegisteredCompaniesCardsCounterr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getActivityStatusList({ commit }, _payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_ACTIVITY_STATUS_LIST_GQL,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_ACTIVITY_STATUS_LIST', data.activityStatusMasters);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getActivityStatusListerr) => {
          console.log(getActivityStatusListerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getNextStepList({ commit }, _payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_NEXT_STEP_LIST_GQL,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_NEXT_STEP_LIST', data.nextStepMasters);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getNextStepListerr) => {
          console.log(getNextStepListerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getRegisteredCardsCount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_REGISTERED_CARDS_COUNT_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          const reponseObj = {
            count: data.cardsConnection.aggregate.count,
            date: Date.now(),
          };
          commit('GET_REGISTERED_CARDS_COUNT', reponseObj);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getRegisteredCardsCounterr) => {
          console.log(getRegisteredCardsCounterr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async setCompanyElTableColumn({ commit }, payload) {
      commit('SET_COMPANY_EL_TABLE_COLUMN', payload.recResCompaniesTblColumnSelection);
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: SET_RECENTLY_REG_COMP_COL_SEL_GQL,
          variables: {
            id: payload.id,
            recResCompaniesTblColumnSelection: payload.recResCompaniesTblColumnSelection.join(),
          },
        })
        .then(() => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((setCompanyElTableColumnerr) => {
          console.log(setCompanyElTableColumnerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Update card type to All when duration changed from registered companies block
    async updateCardType({ commit }, payload) {
      commit('SET_UPDATED_CARD_TYPE', { uniqueId: moment.now(), cardType: payload });
    },
    async getMarqetaTransactionList({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_MARQETA_TRANSACTION_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getMarqetaTransactionListData) => {
          commit('GET_MARQETA_TRANSACTION_LIST', getMarqetaTransactionListData.data.getMarqetaTransactionList);
        })
        .catch(getMarqetaTransactionListErr => {
          commit('GET_MARQETA_TRANSACTION_LIST', { status: 'failure', error: getMarqetaTransactionListErr.message });
        });
    },
    async getProgramBalance({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_PROGRAM_BALANCE_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
          addTypename: false,
        })
        .then(({ data }) => {
          console.log(JSON.parse(data.getProgramReserveBalance.text).ledger_balance)
          commit('GET_PROGRAM_BALANCE', JSON.parse(data.getProgramReserveBalance.text).ledger_balance);

          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getProgramBalanceErr) => {
          console.log(getProgramBalanceErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },    
    async resetMarqetaRawDataRecord({ commit }, payload) {
      await apolloClient
      .mutate({
        mutation: SET_RESET_MARQETA_RAW_DATA_RECORD_GQL,
        variables: payload,
      })
      .then((resetMarqetaRawDataRecordData) => {
        commit('SET_RESET_MARQETA_RAW_DATA_RECORD', resetMarqetaRawDataRecordData.data.resetMarqetaRawDataRecord);
      })
      .catch((resetMarqetaRawDataRecordErr) => {
        commit('SET_RESET_MARQETA_RAW_DATA_RECORD', resetMarqetaRawDataRecordErr.message);
      });
    }
  },
  getters: {
    recentLoggedInUser: state => state.recentLoggedInUser,
    cardTransactionCount: state => state.cardTransactionCount,
    registeredCompaniesList: state => state.registeredCompaniesList,
    registeredCardsList: state => state.registeredCardsList,
    activityStatusList: state => state.activityStatusList,
    nextStepList: state => state.nextStepList,
    registeredCompaniesCardsCount: state => state.registeredCompaniesCardsCount,
    companyCardFilterOffset: state => state.companyCardFilterOffset,
    registeredCardsCount: state => state.registeredCardsCount,
    cardTypeFilter: state => state.cardTypeFilter,
    companyElTableColumn: state => state.companyElTableColumn,
    recentlyRegisteredCompaniesList: state => state.recentlyRegisteredCompaniesList,
    updatedCardType: state => state.updatedCardType,
    marqetaTransactions: state => state.marqetaTransactions,
    updatedMarqetaRawDataRecord: state => state.updatedMarqetaRawDataRecord,
    programBalance: state => state.programBalance,

  },
};
